<article class="baseDialog" dialog>
    @if(dataDialog?.code) {
        <picture class="flex justify-center items-center pb-6 w-full h-auto" style="margin: 0 auto;">
            <img [src]="urlImgError" class="w-52" alt="Cover Header Error" (error)="onImageError('gen')">
        </picture>
    }

    <aside [class]="headerClass()">
        <h3 class="text-[#292a2d] text-[22px] font-medium m-0 pb-2" mat-dialog-title>{{ title() || dataDialog?.title }}</h3>
        
        @if (isLabel() && type() !== typeError) {
            <p class="m-0 text-center text-gray-600 text-base font-normal leading-tight">
                {{ label() || dataDialog?.label }}
            </p>
        }
    </aside>

    <mat-dialog-content class="mat-typography" aria-label="true">
        @switch (type()) {
            @case (typeConfirm) {
                <aside class="bg-red-100 text-red-700 rounded-full px-4 py-2 text-sm">
                    <p class="text-center font-bold italic">{{ editData().content }}</p>
                </aside>
            }

            @default {
                <ng-content select="[body]" />
            }
        }
    </mat-dialog-content>

    @if(isBaseButtonsDialog) {
        <mat-dialog-actions class="grid grid-cols-2 items-center">
            @if (buttonTertiary()) {
                <button 
                    mat-button
                    aria-label="Tertiary action"
                    class="mr-auto"
                    [style]="buttonTertiary()?.style"
                    [disabled]="buttonTertiary()?.isDisabled"
                    (click)="buttonTertiary()?.functionClean()" 
                >
                    {{ buttonTertiary()?.labelButtonClean }}
                </button>
            }  

            <aside class="grid gap-4" [ngClass]="isButtonCancel() && isButtonSuccess() ? 'grid-cols-2' : 'grid-cols-1'" [class.w-full]="!buttonTertiary()">
                @if (isButtonCancel()) {
                    <button 
                        mat-button
                        aria-label="Cancel action"
                        [class.w-full]="!buttonTertiary()" 
                        (click)="reject()" 
                    >
                        {{ dataDialog?.labelButtonCancel || labelButtonCancel() }}
                    </button>
                }
                
                @if (isButtonSuccess()) {
                    <button 
                        mat-flat-button
                        aria-label="Confirm action"
                        style="margin-left: 0 !important;"
                        [class.w-full]="!buttonTertiary()" 
                        [disabled]="disabledButtonOk()"
                        (click)="accept()"
                    >
                        {{ dataDialog?.labelButtonSuccess || labelButtonSuccess() }}
                    </button>
                }
            </aside>
        </mat-dialog-actions>
    }
</article>